import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import "./Home.css";

const Home = () => {
  let context = useAuth();
  let navigate = useNavigate();

  useEffect(() => {
    // signOut(auth);
  }, []);

  useEffect(() => {
    if (context && !context.myChannel && context.myInvites && context.myInvites.length > 0) {
      navigate("/dashboard/invitelist/");
    }
  }, [context]);

  return (
    <section>
      <div className="container">
        <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
          {/* Left Container */}
          <div className="flex flex-col items-start justify-start">
            <h1 className="herotitle">Skarvo</h1>
            <p className="text-xl font-normal">
              Entertain, inform and inspire people around the globe through the power of storytelling, and showcase your iconic brand and creative
              mind.
            </p>
          </div>

          {/* Right Container */}
          <div className="flex flex-col gap-10">
            <div className="flex flex-col items-start formcard">
              <div className="flex flex-row items-start formheader">
                <div className="text-xl font-bold text-center">Skarvo Business</div>
              </div>
              <div className="thickseparator"></div>
              <p className="formexplainertext">
                Sign up to create your <strong>Skarvo Business Account</strong> to access creative tools that provide publishing, creative controls,
                analytics and other features to help you manage and optimize your channel.
              </p>
              <Link to="/accept" className=" w-button herobuttonprimary">
                Sign up
              </Link>
              <div className="thickseparator"></div>
              <p className="formexplainertext">
                Login to your <strong>Skarvo Business Account</strong> to manage your channel.
              </p>

              <Link to="/signin" className=" w-button herobuttonsecondary">
                Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
